<template>
  <div class="main-bg">
    <div class="wrapper">
      <keep-alive>
        <router-view ref="childrenPage"/>
      </keep-alive>
    </div>
    <van-tabbar route placeholder safe-area-inset-bottom :fixed="true">
      <van-tabbar-item replace to="/iframepageyingyong">
        <span>应用</span>
      </van-tabbar-item>
      <van-tabbar-item replace to="/iframepagechanpin">
        <span>产品</span>
      </van-tabbar-item>
      <van-tabbar-item replace to="/iframepagefuwu">
        <span>服务</span>
      </van-tabbar-item>
      <van-tabbar-item replace to="/ai" v-if="this.userId">
        <span>AI助手</span>
      </van-tabbar-item>
      <van-tabbar-item replace to="/personalcenter">
        <span>我的</span>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { getCookie } from '@/utils/auth'
export default {
  name: 'Layout',
  data () {
    return {
      userId: getCookie('userid')
    }
  },
  created () {
    setTimeout(() => {
      this.userId = getCookie('userid')
    }, 1000)
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.main-bg{
  height: 100%;
}
.wrapper{
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  height: calc(100% - 50px);
  width: 100%;
}
</style>
<style>
.van-tabbar-item{
  font-size: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue